(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mh-black-friday-shop"] && !Shopify.designMode) return;
  try {
    
async function initMunchiesBlackFriday(root = document) {
 for (const shop of root.querySelectorAll('[data-mh-bf]')) {
  if (shop.dataset.ready) continue;
  shop.dataset.ready = 'true';
  const grid = shop.querySelector('[data-bf-grid]');
  const buttons = Array.from(shop.querySelectorAll('[data-bf-filter]'));
  const type = shop.querySelector('[data-bf-type]');
  const sort = shop.querySelector('[data-bf-sort]');
  const stock = shop.querySelector('[data-bf-stock]');
  const loading = shop.querySelector('[data-bf-loading]');
  let active = 'all';
  let cards = Array.from(grid.children);
  const eligible = (card,key) => key === 'all' || (key === 'bundles' ? card.dataset.bfBundle === 'true' : card.dataset.bfTiers.includes('|'+key+'|'));
  const refreshCounts = () => buttons.forEach(button => { button.querySelector('[data-bf-tab-count]').textContent = cards.filter(card => eligible(card,button.dataset.bfFilter)).length; });
  const update = () => {
   let count = 0;
   cards.forEach(card => {
    const shown = eligible(card,active) && (type.value === 'all' || card.dataset.bfTypeValue === type.value) && (!stock.checked || card.dataset.bfAvailable === 'true');
    card.hidden = !shown;
    if (shown) count++;
   });
   [...cards].sort((a,b) => sort.value === 'featured' ? Number(a.dataset.bfOrder)-Number(b.dataset.bfOrder) : (Number(a.dataset.bfPrice)-Number(b.dataset.bfPrice))*(sort.value === 'high' ? -1 : 1)).forEach(card => grid.append(card));
   buttons.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.bfFilter === active)));
   shop.querySelector('[data-bf-count]').textContent = count;
   shop.querySelector('[data-bf-empty]').hidden = count !== 0;
   const noOffers = !['all','bundles'].includes(active) && !cards.some(card => eligible(card,active));
   shop.querySelector('[data-bf-empty-offer]').hidden = !noOffers;
   shop.querySelector('[data-bf-empty-general]').hidden = noOffers;
   refreshCounts();
  };
  buttons.forEach(button => button.addEventListener('click',()=>{active=button.dataset.bfFilter;update();}));
  [type,sort,stock].forEach(control => control.addEventListener('change',update));
  shop.querySelector('[data-bf-reset]').addEventListener('click',()=>{active='all';type.value='all';sort.value='featured';stock.checked=false;update();});
  shop.querySelector('.mh-bf__tabs').hidden=false;
  shop.querySelector('.mh-bf__controls').hidden=false;
  update();
  // Load the remaining pages of the collection (the section is capped at 250 products per page)
  const pages = Number(shop.dataset.bfPages || 1);
  const current = Number(shop.dataset.bfPage || 1);
  if (pages > current) {
   if (loading) loading.hidden = false;
   const base = window.location.pathname.replace(/\/$/, '');
   for (let page = current + 1; page <= pages; page++) {
    try {
     const url = `${base}?section_id=${encodeURIComponent(shop.dataset.bfSection)}&page=${page}`;
     const html = await fetch(url, { credentials: 'same-origin' }).then(r => r.text());
     const doc = new DOMParser().parseFromString(html, 'text/html');
     doc.querySelectorAll('[data-bf-grid] > li').forEach(li => grid.append(li));
     // add any product types we have not seen yet
     doc.querySelectorAll('[data-bf-type] option').forEach(opt => { if (![...type.options].some(o => o.value === opt.value)) type.append(opt.cloneNode(true)); });
     cards = Array.from(grid.children);
     update();
    } catch (e) { console.warn('Black Friday page load failed', page, e); }
   }
   if (loading) loading.hidden = true;
   update();
  }
 }
}
initMunchiesBlackFriday();
document.addEventListener('shopify:section:load',event=>initMunchiesBlackFriday(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-curated-collection"]) return;
  try {
    
if (!customElements.get('mh-discovery-shop')) {
  customElements.define('mh-discovery-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.filterBar = this.querySelector('.mh-interest__filters');
      this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-product-group]'));
      this.count = this.querySelector('[data-product-count]');
      this.empty = this.querySelector('[data-empty]');
      this.filterBar.hidden = false;
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const group = button.dataset.filter;
        this.showGroup(group);
        const url = new URL(window.location.href);
        url.hash = group === 'all' ? '' : group;
        window.history.replaceState(null, '', url.toString());
      }));
      this.onHashChange = () => {
        const group = window.location.hash.slice(1);
        this.showGroup(this.buttons.some(button => button.dataset.filter === group) ? group : 'all');
      };
      window.addEventListener('hashchange', this.onHashChange);
      this.onHashChange();
    }
    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHashChange);
      this.initialized = false;
    }
    showGroup(group) {
      let visible = 0;
      this.cards.forEach(card => {
        const show = group === 'all' || card.dataset.productGroup === group;
        card.hidden = !show;
        if (show) visible += 1;
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === group)));
      this.count.textContent = String(visible);
      this.empty.hidden = visible !== 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-foodservice-shop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mh-foodservice-shop')) {
  customElements.define('mh-foodservice-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = Array.from(this.querySelectorAll('[data-bulk-card]'));
      this.grid = this.querySelector('[data-product-grid]');
      this.category = this.querySelector('[data-category-filter]');
      this.size = this.querySelector('[data-size-filter]');
      this.search = this.querySelector('[data-search-filter]');
      this.stock = this.querySelector('[data-stock-filter]');
      this.sort = this.querySelector('[data-sort-filter]');
      this.limit = 12;
      const sizes = new Map();
      this.cards.forEach((card, index) => {
        card.dataset.order = index;
        const select = card.querySelector('[data-pack-select]');
        const initialValue = select.value;
        Array.from(select.options).sort((a,b) => Number(a.dataset.grams) - Number(b.dataset.grams)).forEach(option => {
          select.append(option);
          sizes.set(Number(option.dataset.grams), option.dataset.label);
        });
        select.value = initialValue;
        select.addEventListener('change', () => {
          this.updatePack(card);
          if (this.size.value !== 'all' && Number(select.selectedOptions[0].dataset.grams) !== Number(this.size.value)) this.size.value = 'all';
          this.applyFilters();
        });
        this.updatePack(card);
      });
      Array.from(sizes).sort((a,b) => a[0]-b[0]).forEach(([grams,label]) => {
        const option = document.createElement('option');
        option.value = grams;
        option.textContent = label;
        this.size.append(option);
      });
      this.querySelectorAll('[data-category-count]').forEach(el => {
        el.textContent = this.cards.filter(card => card.dataset.category === el.dataset.categoryCount).length;
      });
      this.querySelectorAll('[data-category-link]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        this.reset();
        this.category.value = link.dataset.categoryLink;
        this.applyFilters();
        this.scrollToProducts();
      }));
      [this.category,this.size,this.stock,this.sort].forEach(control => control.addEventListener('change', () => {
        this.limit = 12;
        this.applyFilters();
      }));
      this.search.addEventListener('input', () => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => { this.limit = 12; this.applyFilters(); }, 180);
      });
      this.querySelectorAll('[data-reset-filters]').forEach(button => button.addEventListener('click', () => {
        this.reset(); this.applyFilters();
      }));
      this.querySelector('[data-load-more]').addEventListener('click', () => {
        const firstNew = this.limit;
        this.limit += 12;
        this.applyFilters(false);
        this.matches[firstNew]?.querySelector('h3 a')?.focus({preventScroll:true});
      });
      this.addEventListener('add-to-cart', () => {
        this.querySelector('[data-added-status]').textContent = this.dataset.added;
        const drawer = document.querySelector('[data-js-site-cart-sidebar]');
        if (drawer && typeof drawer.show === 'function') drawer.show();
      }, true);
      this.onPopState = () => { this.readFilters(); this.applyFilters(false); };
      window.addEventListener('popstate', this.onPopState);
      this.readFilters();
      this.querySelector('[data-filters]').hidden = false;
      this.applyFilters(false);
    }
    disconnectedCallback() {
      clearTimeout(this.searchTimer);
      window.removeEventListener('popstate', this.onPopState);
    }
    updatePack(card) {
      const option = card.querySelector('[data-pack-select]').selectedOptions[0];
      if (!option) return;
      card.querySelector('[data-pack-id]').value = option.value;
      card.querySelector('[data-pack-price]').textContent = option.dataset.money;
      card.querySelector('[data-pack-unit]').textContent = option.dataset.unit;
      card.querySelector('[data-pack-badge]').textContent = option.dataset.label;
      card.querySelector('[data-pack-add]').textContent = option.dataset.available === 'true' ? this.dataset.addTemplate.replace('[size]', option.dataset.label) : this.dataset.soldOut;
      card.querySelector('[type=submit]').disabled = option.dataset.available !== 'true';
      card.querySelectorAll('[data-product-link]').forEach(link => {
        link.href = option.dataset.url;
        if (link.classList.contains('mh-bulk-card__image')) link.setAttribute('aria-label', card.querySelector('h3').textContent.trim() + ' — ' + option.dataset.label);
      });
      const image = card.querySelector('.mh-bulk-card__image img');
      if (image && option.dataset.image && image.getAttribute('src') !== option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
      card.dataset.price = option.dataset.price;
    }
    reset() {
      this.category.value='all'; this.size.value='all'; this.search.value=''; this.stock.checked=false; this.sort.value='featured'; this.limit=12;
    }
    readFilters() {
      this.reset();
      const params = new URLSearchParams(window.location.search);
      [['fs_category',this.category],['fs_size',this.size],['fs_sort',this.sort]].forEach(([key,control]) => {
        const value=params.get(key);
        if (value && Array.from(control.options).some(option => option.value===value)) control.value=value;
      });
      this.search.value=params.get('fs_q') || '';
      this.stock.checked=params.get('fs_stock')==='1';
    }
    applyFilters(writeUrl=true) {
      const words=this.search.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      this.matches=this.cards.filter(card => {
        const select=card.querySelector('[data-pack-select]');
        const eligible=Array.from(select.options).filter(option => (this.size.value==='all' || Number(option.dataset.grams)===Number(this.size.value)) && (!this.stock.checked || option.dataset.available==='true'));
        if (!eligible.length) return false;
        if (!eligible.includes(select.selectedOptions[0])) {
          select.value=(eligible.find(option => option.dataset.available==='true') || eligible[0]).value;
          this.updatePack(card);
        }
        return (this.category.value==='all' || card.dataset.category===this.category.value) && words.every(word => card.dataset.search.includes(word));
      });
      this.matches.sort((a,b) => this.sort.value==='price-up' ? Number(a.dataset.price)-Number(b.dataset.price) : this.sort.value==='price-down' ? Number(b.dataset.price)-Number(a.dataset.price) : Number(a.dataset.order)-Number(b.dataset.order));
      this.cards.forEach(card => { card.hidden=true; });
      const ordered=this.cards.slice().sort((a,b) => this.sort.value==='price-up' ? Number(a.dataset.price)-Number(b.dataset.price) : this.sort.value==='price-down' ? Number(b.dataset.price)-Number(a.dataset.price) : Number(a.dataset.order)-Number(b.dataset.order));
      ordered.forEach((card,index) => { if(this.grid.children[index]!==card) this.grid.insertBefore(card,this.grid.children[index] || null); });
      this.matches.forEach((card,index) => { card.hidden=index>=this.limit; });
      const shown=Math.min(this.limit,this.matches.length);
      this.querySelector('[data-result-count]').textContent=this.dataset.countTemplate.replace('[shown]',shown).replace('[total]',this.matches.length);
      this.querySelector('[data-empty]').hidden=this.matches.length>0;
      this.querySelector('[data-load-more]').hidden=shown>=this.matches.length;
      this.querySelectorAll('[data-category-link]').forEach(link => {
        if (link.dataset.categoryLink===this.category.value) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current');
      });
      if (writeUrl) {
        const url=new URL(window.location.href);
        [['fs_category',this.category.value,'all'],['fs_size',this.size.value,'all'],['fs_q',this.search.value.trim(),''],['fs_stock',this.stock.checked?'1':'',''],['fs_sort',this.sort.value,'featured']].forEach(([key,value,empty]) => { if(value!==empty) url.searchParams.set(key,value); else url.searchParams.delete(key); });
        window.history.replaceState(null,'',url);
      }
    }
    scrollToProducts() {
      const heading=this.querySelector('.mh-fs-products h2') || this.querySelector('h1');
      this.querySelector('.mh-fs-products').scrollIntoView({behavior:'instant',block:'start'});
      heading.focus({preventScroll:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-healthy-choices"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mh-healthy-choices')) {
  customElements.define('mh-healthy-choices', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-healthy-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-healthy-panel]'));
      if (!this.tabs.length) return;
      this.querySelector('.mh-healthy__tabs').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.healthyTab);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].tabIndex = 0;
        tab.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.activate(index);
        }, options);
        tab.addEventListener('keydown', event => {
          if (event.key === ' ') {
            event.preventDefault();
            this.activate(index);
            return;
          }
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next = index;
          if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
          else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          next = (next + this.tabs.length) % this.tabs.length;
          this.activate(next);
          this.tabs[next].focus();
        }, options);
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) this.activate(index);
      }, options);
      this.activate(0);
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }
    activate(index) {
      this.tabs.forEach((tab, current) => {
        tab.setAttribute('aria-selected', String(current === index));
        tab.tabIndex = current === index ? 0 : -1;
        this.panels[current].hidden = current !== index;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-mixes-shop"] && !Shopify.designMode) return;
  try {
    
function initMunchiesMixes(root = document) {
 root.querySelectorAll('[data-mh-mixes]').forEach(shop => {
  if(shop.dataset.ready) return;
  shop.dataset.ready = 'true';
  const grid = shop.querySelector('[data-mh-grid]');
  const cards = Array.from(grid.children);
  const range = shop.querySelector('[data-mh-range]');
  const type = shop.querySelector('[data-mh-type]');
  const sort = shop.querySelector('[data-mh-sort]');
  const update = () => {
   let count = 0;
   cards.forEach(card => {
    const shown = (range.value === 'all' || range.value === card.dataset.mhKind) && (type.value === 'all' || type.value === card.dataset.mhTypeValue);
    card.hidden = !shown;
    if(shown) count++;
   });
   [...cards].sort((a,b) => sort.value === 'featured' ? Number(a.dataset.mhOrder)-Number(b.dataset.mhOrder) : (Number(a.dataset.mhPrice)-Number(b.dataset.mhPrice)) * (sort.value === 'high' ? -1 : 1)).forEach(card => grid.append(card));
   shop.querySelector('[data-mh-count]').textContent = count;
   shop.querySelector('[data-mh-empty]').hidden = count !== 0;
  };
  [range,type,sort].forEach(input => input.addEventListener('change',update));
  shop.querySelector('.mh-mix-controls').hidden = false;
 });
}
initMunchiesMixes();
document.addEventListener('shopify:section:load',event=>initMunchiesMixes(event.target));

  } catch(e) { console.error(e); }
})();
})();
